import * as React from 'react';

import { ChatWindowInitial } from '../../components/ChatWindowInitial';
import { useApplicationContext } from '../../utils/applicationContext';

export const ChatWindowInitialContainer = () => {
  const { config } = useApplicationContext();
  const backgroundImageUrl = config.get<string>('frontend-chats.backgroundImage');

  return <ChatWindowInitial backgroundImageUrl={backgroundImageUrl} />;
};
